import React from 'react'

import TeamStandingsTeamRecord from './TeamStandingsTeamRecord'

const TeamStandingsTeamScores = ({team_standings, measurement_type, hideTeamAnglerRecord,colSpan,length_measurement_symbol,weight_measurement_symbol,team_angler_totals}) => {
 
  if( team_standings ) {
      console.log('team_standings record:::', team_standings.length);
      console.log('colSpan value passed:::',colSpan);
      //console.log('measurement_type value retrieved:::',measurement_type)
  }
 
 
  let angler_record = []

  if(team_standings && (team_standings.length >= colSpan)){
    
    angler_record =  team_standings.slice(0,colSpan).map(({angler_name,angler_total}, index) =>

      <TeamStandingsTeamRecord check_angler_name={angler_name} check_angler_total={angler_total}  check_measurement_type = {measurement_type} check_length_measurement_symbol={length_measurement_symbol} check_weight_measurement_symbol={weight_measurement_symbol} check_team_angler_totals={team_angler_totals} key={`standing${index}`} />
    )
    
 
    
    //console.log('angler record op::',angler_record)
    
    //angler_record.push(<td colSpan={angler_record.length - 1}><div className="standings-fish-score"></div></td>)
  }else if(team_standings &&  team_standings.length < colSpan){

    angler_record =  team_standings.slice(0,colSpan).map(({angler_name,angler_total}, index) =>
      <TeamStandingsTeamRecord check_angler_name={angler_name} check_angler_total={angler_total}  check_measurement_type = {measurement_type} check_length_measurement_symbol={length_measurement_symbol} check_weight_measurement_symbol={weight_measurement_symbol} check_team_angler_totals={team_angler_totals}  key={`standing${index}`} />
    )

    if(colSpan - team_standings.length > 0) {
      angler_record.push(<td colSpan={colSpan - team_standings.length}><div className="standings-fish-score"></div></td>)
    }

  }else {
    angler_record.push(<td colSpan={colSpan}><div className="standings-fish-score"></div></td>)
  }

 

  return (
    <>
    
    {/* ALL IN ONE FISH HEADER
    <td colSpan={colSpan}>
      <div>
        <center>
        {fish}
        </center>
      </div>
    </td> */}
  
   
    {angler_record}
   
    
    
    
    </>
  )
}

export default TeamStandingsTeamScores